export const ADMINISTRATION_TRANSACTION_PENDING_SIGNATURE = "COR023I";

export const CAPTCHA_REQUIRED = "API021W";

export const CAPTCHA_INVALID = "COR050W";
